// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BrandListItem__icon":"uu_a bhi_kb","BrandListItem__name":"uu_b bhi_vn"};